export default __webpack_public_path__ + "static/media/atlas-removebg.98de6102.png";